import React from 'react';
import { Guest, TABLES } from './seatingTypes';
import PrintSeat from './PrintSeat';

interface PrintHonorTableProps {
  assignments: Map<string, Guest>;
  catererIndex: Map<number, number>;
}

const PrintHonorTable: React.FC<PrintHonorTableProps> = ({ assignments, catererIndex }) => {
  const table = TABLES.honor;
  const seatsPerSide = table.seats / 2;

  return (
    <div className="table honor-table">
      <h3>{table.name}</h3>
      <div className="table-layout horizontal">
        <div className="table-side top">
          {Array.from({ length: seatsPerSide }, (_, i) => (
            <PrintSeat
              key={i}
              guest={assignments.get(`honor-${i}`)}
              seatIndex={i}
              seatType="top"
              catererIndex={catererIndex}
            />
          ))}
        </div>
        <div className="table-rectangle"></div>
        <div className="table-side bottom">
          {Array.from({ length: seatsPerSide }, (_, i) => (
            <PrintSeat
              key={i + seatsPerSide}
              guest={assignments.get(`honor-${i + seatsPerSide}`)}
              seatIndex={i + seatsPerSide}
              seatType="bottom"
              catererIndex={catererIndex}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrintHonorTable;
